import ids from './ids';
import i18n from '../../i18n/i18n';

const codes = {};

codes.attachments = 'attachments';

codes.claimAttachments = 'claim-attachments';

codes.jury = 'jury';

codes.landlord = 'landlord';

codes.claimApplicationBankDetailsGroupCode = 'upd-bank-dets';

codes.declarationGroupStep = 'declaration';

codes.claimant = 'CLAIMANT';

codes.addMultipleFiles =
    " Multiple files can be uploaded by clicking 'Add another file'  ";

codes.attachment = 'attachment';

codes.template = 'template';

codes.subscribeCustomer =
    'Please click here to opt in to customer feedback emails.';

codes.unSubscribeCustomer =
    'Please click here to opt out of customer feedback emails.';

codes.authorizedMessage = 'You do not have permissions to perform this action';

codes.blankPage = ' Oops! Something went wrong on our end.';

codes.refreshPage = 'Please use the button below to return to the home page.';

codes.continueContactUs =
    'If you continue to experience problems please contact us.';

codes.emailContactNumberUK = '0117 917 1698';

codes.emailContactEmailUK = 'newclaims@arag.co.uk';

codes.emailContactNumberCA = '1-888-600-0709';

codes.emailContactEmailCA = 'claims@arag.ca';

codes.copyToClipboard = 'Copy to clipboard';

codes.contactIT = 'Please try again, and contact us if the isssue persists.';

codes.unavailableBlankPage = 'Our service is temporarily unavailable.';

codes.unavailableContantIT =
    'Please try again later, if you continue to experience problems please contact us.';

codes.uploading = 'uploading';

codes.removing = 'removing';

codes.downloading = 'downloading';

codes.canadaCode = 'ca';
codes.ukCode = 'uk';
codes.ZcaRelease = 'ZcaRelease';
codes.newRelease = 'newRelease';

codes.enviromentsForIndicator = {
    Development: 'DEV',
    ZukTesting: 'SIT',
    ZukStaging: 'UAT',
    ZukSandbox: 'Sandbox',
    ZcaTesting: 'SIT',
    ZcaStaging: 'UAT',
    ZcaSandbox: 'Sandbox',
};

codes.countries = {
    ca: 'Canada',
    uk: 'UK',
};

codes.surveyTitle =
    'We would love to know what you think about your experience with ARAG, please answer the questions below, it should only take a few minutes!';

codes.surveyRejectedType = 'Rejected';

codes.thresholdMb = 4064;

codes.progressEnd = 100;

codes.attachmentTypeEnum = {
    ClaimForm: 1,
    ArchivedClaimForm: 2,
    ClaimFormQuestion: 3,
    Message: 4,
    ClaimTemplate: 5,
    MediationPdf: 6,
    UnderwriterFile: 7,
    CommunicationDirectAttachment: 9,
};
codes.warnings = 'warnings';

codes.fileNotFound = 'File not found';

codes.blankPageFiles =
    " We're sorry, something went wrong, please try again later.";

codes.defaultPayloadPagination = { page: 1, limit: 20 };
codes.isReadOnlyOrEditableQuestion = {
    isEditable: 'isEditable',
    isReadOnly: 'isReadOnly',
};
codes.isEditable = 'isEditable';

codes.isReadOnly = 'isReadOnly';

codes.Anonymised = 'Anonymised';

codes.anonymisedCodes = {
    Attachments: 'Attachments',
};

codes.namesToDecode = {
    description: 'description',
    filename: 'filename',
};

codes.Attachment = 'Attachment';

codes.dragDrop = 'dragDrop';

codes.acceptSurveyGroupCode = 'accept-surv';

codes.rejectSurveyGroupCode = 'reject-surv';

codes.solicitorSurveyGroupCode = 'solic-surv';

codes.updateWithdrawnDetailsGroupCode = 'upd-wthdr-dets';
codes.checkbox = 'checkbox';

codes.surveysGroupCodesToGroupIds = {
    [codes.acceptSurveyGroupCode]: ids.acceptedSurveyGroupId,
    [codes.rejectSurveyGroupCode]: ids.rejectedSurveyGroupId,
    [codes.solicitorSurveyGroupCode]: ids.solicitorSurveyGroupId,
};

codes.questionTypeIdForCheckboxes = '00000003-1fdd-49c5-99c2-000000000009';
codes.languageIdEnCa = '00000001-1fdd-0049-99c2-000000000003';
codes.languageIdFrCa = '00000001-1fdd-0049-99c2-000000000002';
codes.languageIdEnUk = '00000001-1fdd-0049-99c2-000000000001';

codes.languageFrCaCode = 'fr-CA';
codes.languageEnCaCode = 'en-CA';
codes.languageEnGbCode = 'en-GB';
codes.emptyGuid = '00000000-0000-0000-0000-000000000000';

codes.currencyIdGBP = '00000001-1fdd-0024-99c2-000000000001';
codes.currencyIdEUR = '00000001-1fdd-0024-99c2-000000000002';
codes.currencyIdCAD = '00000001-1fdd-0024-99c2-000000000003';

codes.claimantPerefferedLanguageCode = 'claimant-preferred_language';
export default codes;
